import Button from '~/components/Button';
import { Input } from '~/components/form';
import { Form, useActionData, type V2_MetaFunction } from '~/remix';
import { getErrors } from '~/utils/data';
import { action } from './_route.server';

export { action };

export let meta: V2_MetaFunction = () => [
  { title: 'Sunset Messages - Forgot Password' },
];

export default function () {
  const data = useActionData<typeof action>();
  const errors = getErrors(data);

  return (
    <div>
      <div className="flex justify-center">
        <Form replace method="post" className="space-y-6">
          <div className="flex w-[400px] flex-col items-center p-6">
            <div className="mb-8 w-full bg-white p-6">
              <div className="flex flex-col  gap-4 ">
                <h2 className="text-center text-2xl font-extrabold text-ssm-purple">
                  Forgot Password
                </h2>
                <Input
                  className="mt-8"
                  type="email"
                  name="email"
                  label="Email address"
                  required={true}
                  pattern="[^@\s]+@[^@\s]+(\.[^@\s]+)+"
                  error={errors.email}
                />
              </div>
              <div className="mt-2">
                <span className="text-sm text-red-500">* Required</span>
              </div>
            </div>

            <div>
              <Button type="submit" size="lg" variant="primary">
                Reset Password
              </Button>
            </div>
            {errors.form && (
              <div className="mt-2 text-sm text-red-600">{errors.form}</div>
            )}
          </div>
        </Form>
      </div>
    </div>
  );
}
